// export const BACKEND_URL='http://localhost:5000';
export const BACKEND_URL='https://server-ms-teams.herokuapp.com/';
//export const APP_URL='http://localhost:443';
export const APP_URL='https://ms-teams.netlify.app/';